import { createSelector } from 'reselect'
import { RootStoreState } from '@src/models/app.types'
import { TutorialGroup, TutorialGroups } from './tutorials.types'

export const tutorialsStateSelector = (state: RootStoreState) => state.tutorials
export const tutorialsListSelector = createSelector(
  tutorialsStateSelector,
  (tutorials) => tutorials.tutorials,
)
export const tutorialsLastFetchedAtSelector = createSelector(
  tutorialsStateSelector,
  (tutorials) => tutorials.lastFetchedAt,
)

export const tutorialGroupFromTutorialsSelector = (groupKind?: TutorialGroups) => {
  return createSelector(tutorialsStateSelector, (tutorialsState) => {
    if (groupKind === undefined) {
      return
    }

    const tutorials = tutorialsState.tutorials
      .filter((tutorial) => tutorial.tutorialGroupKind === groupKind)
      .sort((a, b) => Number(a.position) - Number(b.position))

    if (tutorials.length === 0) {
      return
    }

    const cmsGroup = tutorialsState.groups.find(({ kind }) => kind === groupKind)
    const firstTutorial = tutorials[0]

    const tutorialGroup: TutorialGroup = {
      kind: groupKind,
      title: cmsGroup?.title || firstTutorial.tutorialGroupTitle || groupKind,
      duration: cmsGroup?.duration || firstTutorial.tutorialGroupDuration || '',
      summary: cmsGroup?.summary || firstTutorial.tutorialGroupSummary || '',
      tutorials: tutorials.map((tutorial) => ({
        id: tutorial.id,
        position: tutorial.position,
        name: tutorial.name,
        title: tutorial.title,
        duration: tutorial.duration,
        description: tutorial.description,
        buttonText: tutorial.buttonText,
        image: tutorial.image,
        platform: tutorial.platform,
        sensorKind: tutorial.sensorKind,
      })),
    }

    return tutorialGroup
  })
}

export const currentTutorialSelector = createSelector(
  tutorialsStateSelector,
  (tutorials) => tutorials.currentTutorial,
)
